var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 42.3334,
    rx: 21.1667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 42.3334,
    rx: 21.1667,
    stroke: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 17.334L26.5869 24.0174C26.4813 25.7249 26.4285 26.5787 26.0005 27.1926C25.7889 27.4961 25.5165 27.7522 25.2005 27.9447C24.5614 28.334 23.706 28.334 21.9951 28.334C20.2821 28.334 19.4255 28.334 18.786 27.9439C18.4699 27.7511 18.1973 27.4945 17.9858 27.1905C17.5579 26.5757 17.5063 25.7207 17.4031 24.0108L17 17.334",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.3333H28M24.7038 17.3333L24.2487 16.3945C23.9464 15.7708 23.7952 15.459 23.5345 15.2645C23.4767 15.2214 23.4154 15.183 23.3513 15.1498C23.0626 15 22.7161 15 22.023 15C21.3125 15 20.9573 15 20.6638 15.1561C20.5987 15.1907 20.5367 15.2306 20.4782 15.2754C20.2144 15.4778 20.0671 15.801 19.7724 16.4475L19.3686 17.3333",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 24.666V20.666",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.667 24.666V20.666",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddelete);
export default __webpack_public_path__ + "static/media/reddelete.60674085c5c8c5a1cb35e9c7df98136c.svg";
export { ForwardRef as ReactComponent };